import React, {useEffect, useState} from 'react'
// Styles
import formStyles from './forms.module.scss'

interface SelectOption {
  value: string
  label: string
}

interface InputSelectProps {
  id: string
  label: string
  instructions?: React.ReactNode
  options: SelectOption[]
  initialValue?: string
  errorMessage?: string | null
  // isDisabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>, id: string) => void
}

const InputSelect = ({
  id,
  label,
  instructions,
  options,
  initialValue = '',
  errorMessage = null,
  // isDisabled = false,
  onChange,
}: InputSelectProps) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleChange = (syntheticEvent: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(syntheticEvent.target.value)

    if (onChange) onChange(syntheticEvent, id)
  }

  return (
    <div
      key={`field-${id}`}
      className={formStyles['__select-wrapper']}
    >
      <label className={formStyles['__label']}>{label}</label>
      <select
        value={value}
        onChange={handleChange}
        className={formStyles['__field']}
      >
        <option
          value=""
          disabled
          hidden
          className={formStyles['__option']}
        >
          Select an option
        </option>
        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
            className={formStyles['__option']}
          >
            {option.label}
          </option>
        ))}
      </select>
      <div className={formStyles['__caret']}>
        ▼
      </div>
      {errorMessage && (
        <span className={formStyles['__error-message']}>
          {errorMessage}
        </span>
      )}
      <div className={formStyles['__instructions']}>{instructions}</div>
    </div>
  )
}

export default InputSelect
